import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { setDrawingToolSelected } from "@/components/DrawingNav/drawingSlice";
import LayerList from "@/components/LayerList";
import ParcelDetail from "@/components/ParcelDetail";
import SavedItemList from "@/components/SavedItemList";
import { currentSelectedSearchResult } from "@/components/Search/searchSlice";
import { SHAPE_LABELS } from "@/lib/saved-items";
import { SHAPE_ICONS } from "@/lib/shape-icons";
import type { ShapeOptions } from "@/types";
import { Center, Grid, Image, Text } from "@mantine/core";
import { useEffect } from "react";
import ExploreMenuItem from "./components/ExploreMenuItem";
import LayersMenuItem from "./components/LayersMenuItem";
import SavedItemsMenuItem from "./components/SavedItemsMenuItem";
import ToolsMenuItem from "./components/ToolsMenuItem";
import { selectedMenuItem, setNavigationMenuLayout, setSelectedMenuItem } from "./menuSlice";

const DRAWING_TOOLS: ShapeOptions[] = ['line', 'polygon', 'point'];

const Menu: React.FC = () => {
    const currentMenuItem = useAppSelector(selectedMenuItem);
    const currentSearchResult = useAppSelector(currentSelectedSearchResult);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (currentSearchResult?.attributes) {
            dispatch(setSelectedMenuItem('explore'))
        }
    }, [currentSearchResult, dispatch])

    const onShapeClickHandler = (shape: ShapeOptions) => {
        dispatch(setNavigationMenuLayout('drawing'))
        dispatch(setDrawingToolSelected(shape))
    }

    return (
        <Grid gutter={{ base: 0 }} h="65px" bg="black" mb={0}>
            <Grid.Col span={3}>
                <ExploreMenuItem>
                    {currentMenuItem === 'explore' && currentSearchResult?.attributes && <ParcelDetail parcelDetails={currentSearchResult.attributes} />}
                </ExploreMenuItem>
            </Grid.Col>
            <Grid.Col span={3}>
                <LayersMenuItem>
                    <LayerList />
                </LayersMenuItem>
            </Grid.Col>
            <Grid.Col span={3}>
                <SavedItemsMenuItem>
                    <SavedItemList />
                </SavedItemsMenuItem>
            </Grid.Col>
            <Grid.Col span={3}>
                <ToolsMenuItem>
                    <Grid mt={10}>
                        {DRAWING_TOOLS.map((shape) => (
                            <Grid.Col span={4} key={shape}>
                                <Center style={{ textAlign: 'center' }} onClick={() => onShapeClickHandler(shape)}>
                                    <Image h={35} fit='contain' src={SHAPE_ICONS[shape]} alt={`${SHAPE_LABELS[shape]} Icon`} />
                                    <Text mt={10}>{SHAPE_LABELS[shape]}</Text>
                                </Center>
                            </Grid.Col>
                        ))}
                    </Grid>
                </ToolsMenuItem>
            </Grid.Col>
        </Grid>
    );
}

export default Menu;
